import React from "react";

const TONES = {
    neutral: "bg-ink-100 text-ink-700 ring-ink-200",
    brand: "bg-brand-50 text-brand-700 ring-brand-100",
    success: "bg-success-50 text-success-700 ring-success-100",
    warning: "bg-warning-50 text-warning-800 ring-warning-100",
    danger: "bg-danger-50 text-danger-700 ring-danger-100",
    info: "bg-info-50 text-info-700 ring-info-100",
};

const Badge = ({ children, tone = "neutral", className = "" }) => {
    const cls = TONES[tone] || TONES.neutral;
    return (
        <span
            className={`inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-xs font-medium ring-1 ring-inset ${cls} ${className}`}
        >
            {children}
        </span>
    );
};

export default Badge;
